// utils/tokenHelper.js
export const isTokenExpired = (token) => {
    if (!token) return true;
    
    try {
        // Split the token and decode the payload
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const payload = JSON.parse(atob(base64));
        
        // Check if exp exists and if it's expired
        if (!payload.exp) return true;
        
        // exp is in seconds, convert to milliseconds
        const expirationTime = payload.exp * 1000;
        const currentTime = Date.now();
        
        return currentTime >= expirationTime;
    } catch (error) {
        console.error("Error decoding token:", error);
        return true;
    }
};

// Get token expiration time
export const getTokenExpiration = (token) => {
    if (!token) return null;
    
    try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        return new Date(payload.exp * 1000);
    } catch (error) {
        return null;
    }
};

// Get time until token expires (in seconds)
export const getTokenTimeRemaining = (token) => {
    if (!token) return 0;
    
    try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        const expirationTime = payload.exp * 1000;
        const currentTime = Date.now();
        const remaining = expirationTime - currentTime;
        
        return Math.max(0, Math.floor(remaining / 1000)); // seconds remaining
    } catch (error) {
        return 0;
    }
};


export const refreshToken = async () => {
    try {
        const response = await fetch(`${import.meta.env.VITE_API_URL}/auth/refresh`, {
            method: 'POST',
            credentials: 'include'
        });
        if (response.ok) {
            const data = await response.json();
            return data.token; // Assuming the new token is returned in this format
        } else {
            console.error("Failed to refresh token:", response.status);
            return null;
        }
    } catch (error) {
        console.error("Error refreshing token:", error);
        return null;
    }
};